<template>
  <Modal
    :visible="isModal"
    pop_tit="분석보고서 열람 인증 및 다운로드"
    popSizeClass="popup__container--l"
    @close="closeModal"
  >
    <template #pop_content>
      <div class="notice-box">
        <p class="notice-box__text">
          1. 분석보고서 열람을 위한 비밀번호를 이메일로 전송하였습니다.<br />
          2. 메일을 확인하신 후 비밀번호 입력 및 인증이 완료되면 분석보고서가
          다운로드됩니다.<br />
          3. 분석보고서 파일 암호는 열람 비밀번호와 동일합니다.<br />
          4. 비밀번호 인증 유효 시간은 15분이며, 시간이 경과할 경우 인증이
          만료됩니다.
        </p>
      </div>
      <div class="board-wrapper">
        <table class="board-write type-block--mobile">
          <caption>
            분석보고서
          </caption>
          <tbody>
            <tr>
              <th scope="row">비밀번호</th>
              <td>
                <input
                  type="text"
                  id="input1"
                  placeholder="비밀번호를 입력하십시오"
                  v-model="password"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #pop_buttons>
      <button
        type="button"
        class="btn btn--m btn--blue"
        @click="applySelection"
      >
        분석보고서 다운로드
      </button>
    </template>
  </Modal>
</template>
<script>
import Modal from "@/component/Modal.vue";
import { inject, ref } from "vue";
import { useStore } from "vuex";

export default {
  components: { Modal },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    reportKve: {
      type: String,
      default: null,
    },
  },
  setup(props, { emit }) {
    const axios = inject("axios");
    const saver = inject("filesaver");
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const password = ref("");

    //methods 정의
    const applySelection = () => {
      showLoading();

      axios({
        method: "POST",
        url: "/patch/pr/submission/analysis/download",
        responseType: "blob",
        headers: { "Content-Type": "application/json" },
        data: { kve: props.reportKve, password: password.value },
      })
        .then(async (response) => {
          hideLoading();

          // blob → 텍스트 변환 후 JSON 여부 확인
          const text = await response.data.text();
          try {
            const json = JSON.parse(text);
            if (json.resType === "RES_ERROR") {
              alert(json.resMsg);
              return;
            }
              
            
          } catch (e) {
            if (response.data.size === 0) {
                alert("해당 경로에 파일이 존재하지 않습니다.");
                return;
              }

              const blob = new Blob([response.data], {
                type: "application/octet-stream",
              });
              // KVE  새로운 파일명 생성
              const newFileName = `${props.reportKve}_분석보고서.7z`;
              saver.saveAs(blob, newFileName);
              closeModal();
          
          
          }
        })
        .catch((error) => {
          console.log(error);
          hideLoading();
        });
    };

    const closeModal = () => {
      emit("close");
    };

    // html에서 사용될 데이터 정의
    return {
      password,
      closeModal,
      applySelection,
    };
  },
};
</script>
